import { createSelector } from 'reselect';

import { getRoot } from 'utils/selectors';

import { getContextByIds, getContextById } from './context';
import { getUIState } from './general';

const getUIHistory = createSelector(getUIState, state => state.details.history.list);

export const getHistoryIds = createSelector(getUIHistory, state => state.ids);

export const getHistoryPage = createSelector(getUIHistory, state => state.page);

export const isHistoryLoading = createSelector(getUIHistory, state => state.loading);

export const hasMoreHistoryEntries = createSelector(getUIHistory, state => state.hasMore);

export const getHistoryError = createSelector(getUIHistory, state => state.error);

export const getHistorySelectEntries = createSelector(getRoot, getHistoryIds, getContextByIds);

export const getSelectedHistoryId = createSelector(getUIState, state => state.details.history.selected);

export const getSelectedHistory = createSelector(getRoot, getSelectedHistoryId, getContextById);
